import React, {Dispatch, SetStateAction} from "react";
import icons from "components/UI/icons/icons";
import images from "components/UI/images";
import {dropdownsStateKey, dropdownType, ProjectListType, SocialListType} from "components/Header";
import socials from "components/UI/icons/socials";

const Dropdown = React.forwardRef<HTMLDivElement, IDropdownProps>((
    {
        body,
        head,
        variant,
        isOpen,
        type,
        setCurrent,
        className = "",
        ...props
    }, ref
) => {
    const {ImageProject} = images;
    const {IconChevron, IconSocial} = icons;

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();

        setCurrent((prevState) => {
            let key: dropdownsStateKey = "" as dropdownsStateKey;

            for (key in prevState) {
                if (key === type) {
                    prevState[key] = !isOpen;
                } else {
                    prevState[key] = false;
                }
            }

            return {...prevState};
        });
    };

    return (
        <div ref={ref} className={`${className} dropdown`}>
            <button onClick={handleClick} className={`dropdown__head ${isOpen ? "active" : ""}`}>
                {
                    head.element === "ElementIconSocial" ? <span className="dropdown__icon">
                        <IconSocial/>
                    </span> : null
                }
                {
                    head.element === "ElementImageProject" ? <div className="dropdown__image">
                            <img src={ImageProject} alt="project logo" title="project logo"/>
                        </div>
                        : null
                }
                <span className={`dropdown__title dropdown__title--${variant}`}>{head.text}</span>
                <span className="dropdown__arrow" aria-label="arrow">
                    <IconChevron/>
                </span>
            </button>

            <div className={`dropdown__body ${isOpen ? "dropdown__body--open" : ""}`}>
                <div className="dropdown__body-wrapper">
                    {
                        body.socialList?.length ? body.socialList.map((item, index) => {
                            const {url, icon, text} = item;
                            const Icon = socials[icon];
                            return <a key={index} className={`dropdown__option dropdown__option--${variant}`}
                                      target="_blank"
                                      rel="noreferrer" href={url}>
                            <span className="dropdown__option-icon">
                                <Icon/>
                            </span>
                                <span className="dropdown__option-text">{text}</span>
                            </a>
                        }) : null
                    }
                    {
                        body.projectList?.length ? body.projectList.map((item, index) => {
                            const {url, images: imagesList, text} = item;
                            const rootClass = `dropdown__option dropdown__option--project ${imagesList.length > 1 ? "dropdown__option--more-image" : ""} dropdown__option--${variant}`;
                            return <a key={index} className={rootClass} target="_blank" rel="noreferrer" href={url}>
                                <div className="dropdown__option-image-wrapper">
                                    <div className="dropdown__option-image">
                                        {
                                            imagesList.map((image, index) => {
                                                return <img key={index} src={images[image]}
                                                            alt={text} title={text}/>
                                            })
                                        }
                                    </div>
                                </div>
                            </a>
                        }) : null
                    }
                </div>
            </div>
        </div>
    );
});

export default Dropdown;

interface IDropdownProps {
    className?: string;
    setCurrent: Dispatch<SetStateAction<dropdownType>>;
    variant?: "default" | "line",
    isOpen: boolean;
    type: dropdownsStateKey,
    head: {
        text: string,
        element: "ElementIconSocial" | "ElementImageProject",
    }
    body: {
        socialList?: SocialListType[],
        projectList?: ProjectListType[],
    }
}